import { LicenseInfo } from '@mui/x-license'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import SiteRouter from './Routes/SiteRouter'
import { store } from './redux/store'
import './utils/consolePresentation'
import GlobalNotification from './components/GlobalNotification/GlobalNotification';
import MaintenanceBanner from './components/GlobalNotification/MaintenanceBanner'; 

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

LicenseInfo.setLicenseKey('e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y')

root.render(
  <Provider store={store}>
    {/* <StrictMode> */}
    <MaintenanceBanner />
    <GlobalNotification />
    <SiteRouter />
    {/* </StrictMode> */}
  </Provider>
)